import { BadgeDollarSign } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function AdvertisingPage() {
  return (
    <PhaseStubPage
      title="Advertising"
      phase={6}
      modules={[
        'Per-platform spend, impressions, clicks, CPA, ROAS',
        'Cross-platform daily spend rollup via shared ad_spend_daily view',
        'Campaign + ad-set drilldown with creative previews',
        'Budget pacing vs. plan with anomaly flags',
      ]}
      icon={BadgeDollarSign}
    />
  );
}
